export default {
  tabs: {
    gift_cards: 'Tarjetas regalo',
    settings: 'Ajustes',
  },
  gift_cards: {
    title: 'Tarjetas regalo',
    subtitle: 'Gestiona todas las tarjetas regalo de tu restaurante',
    buttons: {
      create: 'Crear tarjeta regalo',
      redeem: 'Canjear tarjeta regalo',
      check_balance: 'Consultar saldo',
    },
    search: {
      placeholder: 'Introduce texto de búsqueda',
    },
    columns: {
      code: 'Código',
      status: 'Estado',
      balance: 'Saldo',
      value: 'Valor',
      email: 'Comprador',
      source: 'Origen',
      created_at: 'Creado',
    },
    statuses: {
      active: 'Activo',
      partially_redeemed: 'Parcialmente canjeado',
      redeemed: 'Canjeado',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Ajustes de tarjetas regalo',
      subtitle: 'Configura las opciones de tarjetas regalo de tu restaurante',
      availability: {
        title: 'Activar tarjetas regalo',
        subtitle: 'Permite a los clientes comprar y canjear tarjetas regalo',
        buttons: {
          enable: 'Activar',
          disable: 'Desactivar',
        },
      },
    },
    redemption_options: {
      title: 'Opciones de canje',
      subtitle: 'Elige dónde los clientes pueden canjear tarjetas regalo',
      redemption_mode: {
        title: 'Modo de canje',
        subtitle: 'Esto afecta al texto de tu página de tarjetas regalo',
        buttons: {
          online: 'Solo online',
          online_and_store: 'Online y en tienda',
        },
      },
    },
  },
  summary: {
    total_value: 'Valor total',
    total_active: 'Total activas',
    redeemed_this_month: 'Canjeadas este mes',
  },
};
